import { Image } from "expo-image";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { LessonMetaRow } from "./LessonMetaRow";
import type { Lesson } from "./types";

type Props = {
	lesson: Lesson;
	onPress: (lesson: Lesson) => void;
};

export const LessonListItem = ({ lesson, onPress }: Props) => {
	const theme = useAppTheme();

	return (
		<FlatCard
			onPress={() => onPress(lesson)}
			style={{
				borderWidth: 1,
				borderColor: theme.colors.outlineVariant,
			}}
		>
			<Box flexDirection="row" alignItems="flex-start" gap={16} padding={12}>
				<Image
					source={lesson.thumbnailUrl}
					contentFit="cover"
					style={{
						flexShrink: 0,
						width: 96,
						height: 96,
						borderRadius: theme.roundness * 3,
						borderWidth: 1,
						borderColor: theme.colors.outlineVariant,
						backgroundColor: theme.colors.elevation.level3,
					}}
				/>
				<Box flex={1} gap={8}>
					<Box gap={4}>
						<Text variant="bodyLarge">{lesson.title}</Text>
						<Text
							variant="bodyMedium"
							numberOfLines={2}
							style={{ color: theme.colors.onSurfaceVariant }}
						>
							{lesson.description}
						</Text>
					</Box>
					<LessonMetaRow meta={lesson.meta} />
				</Box>
			</Box>
		</FlatCard>
	);
};
